module.exports = __webpack_public_path__ + "img/BS19.990f26bf.svg";